<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4>Product prices for {{ customer.company_name || '...' }}</h4>
                                <p class="text-muted mb-0">
                                    These prices will be used in forms for this customer.
                                </p>
                            </div>
                            <div>
                                <router-link
                                    :to="{ name: 'office.customers.show', params: { id: id } }"
                                    class="btn btn-outline-secondary"
                                >
                                    <i class="fa fa-arrow-left" /> Back to customer
                                </router-link>
                                <button
                                    class="btn btn-primary"
                                    @click="showAddModal"
                                >
                                    <i class="fa fa-plus" /> Add product
                                </button>
                            </div>
                        </div>
                        <table
                            v-if="customerProducts.length"
                            class="table mt-3 products-table"
                        >
                            <thead>
                                <tr>
                                    <th>Photo</th>
                                    <th>Product</th>
                                    <th>Original Price</th>
                                    <th>Custom Price</th>
                                    <th class="text-right">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="cp in customerProducts"
                                    :key="cp.id"
                                >
                                    <td>
                                        <img
                                            v-if="cp.product && cp.product.photo_url"
                                            :src="cp.product.photo_url"
                                            :alt="cp.product ? cp.product.name : ''"
                                        >
                                        <span v-else>No Photo</span>
                                    </td>
                                    <td>
                                        {{ cp.product ? cp.product.name : '' }}{{ cp.product && cp.product.code ? ' - ' + cp.product.code : '' }}
                                    </td>
                                    <td>£{{ (cp.product && cp.product.unit_price ? cp.product.unit_price : 0) | money }}</td>
                                    <td>
                                        £{{ (cp.price || 0) | money }}
                                        <span
                                            v-if="cp.product && cp.product.unit_price != null && priceDiff(cp) !== 0"
                                            :class="priceDiff(cp) > 0 ? 'text-success' : 'text-danger'"
                                        >
                                            ({{ priceDiff(cp) > 0 ? '+' : '' }}£{{ priceDiff(cp) | money }})
                                        </span>
                                    </td>
                                    <td class="text-right">
                                        <button
                                            class="btn btn-sm btn-outline-info"
                                            type="button"
                                            @click="showEditModal(cp)"
                                        >
                                            <i class="fa fa-pencil-alt" /> Edit
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p
                            v-else-if="!customerProductsLoading"
                            class="text-muted mt-3 mb-0"
                        >
                            No product prices set for this customer.
                        </p>
                        <p
                            v-else
                            class="text-muted mt-3 mb-0"
                        >
                            Loading...
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <customer-product-modal
            v-if="modalOpen"
            :customer-id="id"
            :products="products"
            :customer-products="customerProducts"
            :editing-product="modalEditingProduct"
            @saved="onModalSaved"
            @deleted="onModalDeleted"
            @close="modalOpen = false"
        />
    </div>
</template>
<script>
import CustomerService from '../../../services/CustomerService';
import CustomerProductService from '../../../services/CustomerProductService';
import ProductsService from '../../../services/ProductsService';
import UsesErrors from '../../../mixins/UsesErrors';
import UsesInfoMessage from '../../../mixins/UsesInfoMessage';

import CustomerProductModal from './CustomerProductModal.vue';

export default {
    components: {
        CustomerProductModal,
    },
    mixins: [UsesErrors, UsesInfoMessage],
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            customer: {},
            products: [],
            customerProducts: [],
            customerProductsLoading: false,
            modalOpen: false,
            modalEditingProduct: null,
        };
    },
    mounted() {
        CustomerService.get(this.id).then(
            xhr => {
                this.customer = xhr.data;
            }
        );
        this.loadProducts();
        this.loadCustomerProducts();
        this.listenForUpdates();
    },
    beforeDestroy() {
        this.stopListeningForUpdates();
    },
    methods: {
        showAddModal() {
            this.modalEditingProduct = null;
            this.modalOpen = true;
        },
        showEditModal(customerProduct) {
            this.modalEditingProduct = customerProduct;
            this.modalOpen = true;
        },
        onModalSaved() {
            this.modalOpen = false;
            this.modalEditingProduct = null;
            this.loadCustomerProducts();
        },
        onModalDeleted() {
            this.modalOpen = false;
            this.modalEditingProduct = null;
            this.loadCustomerProducts();
        },
        priceDiff(cp) {
            var original = parseFloat(cp.product && cp.product.unit_price);
            var custom = parseFloat(cp.price);
            if (isNaN(original) || isNaN(custom)) return 0;
            return Math.round((custom - original) * 100) / 100;
        },
        loadProducts() {
            ProductsService.index().then(res => {
                this.products = res.data;
            });
        },
        loadCustomerProducts() {
            this.customerProductsLoading = true;
            CustomerProductService.index(this.id).then(res => {
                this.customerProducts = res.data;
            }).finally(() => {
                this.customerProductsLoading = false;
            });
        },
        listenForUpdates() {
            if (!window.Echo) return;
            const channel = window.Echo.private('customer.' + this.id);
            channel.listen('CustomerProductChanged', () => {
                this.loadCustomerProducts();
            });
        },
        stopListeningForUpdates() {
            if (!window.Echo) return;
            window.Echo.leave('customer.' + this.id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/customers/ProductsComponent.vue